export default __webpack_public_path__ + "static/media/contextual-chocolate@3x.39a24e97.png";